/**
 * Google Map frontend initialization.
 *
 * Called once by the Google Maps JS SDK bootstrap loader (callback=wpbInitGoogleMaps).
 * Renders every queued map instance pushed onto window.wpbGoogleMaps by render.php.
 *
 * AdvancedMarkerElement (the non-deprecated replacement for google.maps.Marker)
 * requires a Map ID to render, so instances without one fall back to Google's
 * public demo Map ID.
 */
window.wpbInitGoogleMaps = async () => {
	const configs = window.wpbGoogleMaps || [];

	if (!configs.length) {
		return;
	}

	const { Map, InfoWindow } = await google.maps.importLibrary("maps");
	const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

	configs.forEach((config) => {
		const container = document.getElementById(config.id);

		if (!container) {
			return;
		}

		const map = new Map(container, {
			center: { lat: config.lat, lng: config.lng },
			zoom: config.zoom,
			mapId: config.mapId || "DEMO_MAP_ID",
		});

		const marker = new AdvancedMarkerElement({
			position: { lat: config.lat, lng: config.lng },
			map,
			title: config.title || "",
		});

		if (config.showInfoWindow && config.title) {
			const content = document.createElement("div");
			content.className = "wpb-google-map__info-window";
			content.textContent = config.title;

			const infoWindow = new InfoWindow({
				content,
			});

			infoWindow.open({ map, anchor: marker });

			marker.addListener("click", () => {
				infoWindow.open({ map, anchor: marker });
			});
		}
	});
};
